import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, switchMap } from 'rxjs';

import { MultiUserPreferenceService } from 'app/features/settings/services';
import { resetApiConfig } from 'app/state/api-config/api-config.actions';
import {
    initializedMultiUserPreferenceStore,
    initializingMultiUserPreferenceStore,
    resetMultiUserPreferences,
} from 'app/state/multi-user-preferences/multi-user-preferences.actions';
import { selectMultiUserPreferences } from 'app/state/multi-user-preferences/multi-user-preferences.selectors';

// noinspection JSUnusedGlobalSymbols
@Injectable()
export class MultiUserPreferencesEffects {
    initializingMultiUserPreferenceStore = createEffect(() =>
        this.actions$.pipe(
            ofType(initializingMultiUserPreferenceStore),
            map(() => {
                const preferences = this.preferenceService.getMultiUserPreferencesFromStorageOrDefault();
                return initializedMultiUserPreferenceStore({ preferences });
            }),
        ),
    );

    resetPreferencesOnApiConfigReset$ = createEffect(() =>
        this.actions$.pipe(
            ofType(resetApiConfig),
            map(() => resetMultiUserPreferences()),
        ),
    );

    syncMultiUserPreferencesInStorage = createEffect(
        () =>
            this.actions$.pipe(
                ofType(initializedMultiUserPreferenceStore),
                switchMap(() => this.store.select(selectMultiUserPreferences)),
                map((preferences) => {
                    if (preferences) this.preferenceService.putMultiUserPreferencesToStorage(preferences);
                    else this.preferenceService.clearMultiUserPreferencesFromStorage();

                    return true;
                }),
            ),
        { dispatch: false },
    );

    constructor(
        private actions$: Actions,
        private preferenceService: MultiUserPreferenceService,
        private store: Store,
    ) {}
}
